import { Common } from '@stockbit/ui';

const {
  Flex,
  Tag: { Tag },
  Text,
} = Common;

export const renderStockSuggestions = (stocks = []) =>
  stocks.map((stock) => ({
    value: stock.name,
    label: (
      <Flex align="center">
        <Tag size="xs" type="grey">
          {stock.name}
        </Tag>
        <Text pl="10px" size="13px">
          {stock.desc}
        </Text>
      </Flex>
    ),
  }));

export default {};
